import React from "react";
import ReactDOM from "react-dom";
import "./styles.css"; // Add your custom styles for the modal

const Modal = ({ children, isOpen, onClose }) => {
  // If the modal is not open, don't render anything
  if (!isOpen) return null;

  // Create a portal to render the modal
  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        style={{ width: "auto", overflow: "visible" }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        {children}
      </div>
    </div>,
    document.getElementById("modal-root") // Render modal inside this element
  );
};

export default Modal;
